import { useQuery } from "@tanstack/react-query";
import fetchApi from "../fetchApi";

const useQueryLogo = ({
  groupType,
  corporateId,
  enabled = true,
  authorisation = "",
}: {
  groupType: string;
  corporateId: string;
  enabled?: boolean;
  authorisation?: string;
}) => {
  return useQuery(
    ["logo"],
    () =>
      fetchApi(`${groupType}/${corporateId}/logo`, {
        headers: {
          Authorization: `Bearer ${authorisation}`,
        },
      }).logo(),
    {
      staleTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      enabled,
    }
  );
};

export default useQueryLogo;
